<template>
  <b-row>
    <b-col cols="12" class="mb-1">
      <h3 class="">
        ตรวจสอบข้อมูล
      </h3>

      <div class="border border-primary rounded-lg mt-2">
        <b-col md="12">
          <h3 v-if="isAttorneyCompliant === false" class="mb-0">
            ข้อมูลผู้ร้องทุกข์
          </h3>
          <h3 class="mb-0" v-else>
            ผู้ดำเนินการ
          </h3>

          <div
            v-for="(item, index) in personals"
            :id="item.id"
            :key="'personal' + index"
            class="container"
          >
            <b-list-group flush>
              <PersonDataDigital
                :AllowDelete="false"
                :IsReadOnly="true"
                :IsDeleteAble="false"
                :person="item"
              />
            </b-list-group>

            <!-- <Personal
              :personal="item"
              :IsReadOnly="true"
            /> -->
          </div>
        </b-col>
      </div>

      <div class="border border-primary rounded-lg mt-2">
        <b-col md="12">
          <h3 class="mt-1">
            ผู้มอบอำนาจ
          </h3>

          <div
            v-for="(item, index) in attorneys"
            :id="item.id"
            :key="'attorney' + index"
            class="container"
          >
            <b-list-group flush>
              <PersonDataDigital
                :AllowDelete="false"
                :IsReadOnly="true"
                :IsDeleteAble="false"
                :person="item"
              />
            </b-list-group>

            <!-- <Personal
              :personal="item"
              :IsReadOnly="true"
            /> -->
          </div>
        </b-col>
      </div>

      <div class="border border-primary rounded-lg mt-2">
        <b-col md="12">
          <Step2
            class="mt-1"
            :company="company"
            :IsReadOnly="true"
            :IsEdit_CompanySearch="false"
            :complainantCompany="complainantCompany"
          />
        </b-col>
      </div>

      <div class="border border-primary rounded-lg mt-2">
        <b-col md="12">
          <Step3
            class="mt-1"
            :complaintDetail="complaintDetail"
            :complaintDetailMultiSelect="complaintDetailMultiSelect"
            :complaintCatagoryDetail="complaintCatagoryDetail"
            :IsReadOnly="true"
          />
        </b-col>
      </div>

      <div
        class="border border-primary rounded-lg mt-2"
        v-if="mouCompanies != null && mouCompanies.length > 0"
      >
        <b-row class="col-12 p-1">
          <b-col cols="12">
            <h3 class="mb-0">
              เข้าร่วม FastTrack
            </h3>
          </b-col>
          <b-col cols="12" class="mt-1 mb-1">
            <b-form-group label="ต้องการเข้าร่วม Fasttrack หรือไม่?">
              {{ needFastTrack ? "ต้องการ" : "ไม่ต้องการ" }}
            </b-form-group>
          </b-col>

          <b-row class="col-12" v-if="needFastTrack">
            <b-col cols="6">
              <b-form-group label="ผู้ประกอบการที่ส่งข้อมูล Fastrack">
                {{ selectedCompanyMOU.companyDetail }}
                <b-img
                  :src="
                    require('@/assets/images/logo/fasttrack/fasttrack_mou.png')
                  "
                  alt="Fasttrack icon"
                  class="fast-track-icon"
                />
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group label="หมายเลขคำสั่งซื้อ">
                {{ selectedCompanyMOU.purchaseNo }}
              </b-form-group>
            </b-col>
            <b-col cols="12" class="mt-1">
              ไฟล์แนบรายละเอียดคำสั่งซื้อ
            </b-col>
            <b-col cols="12" class="mt-1 px-2">
              <ul class="list-unstyled mb-0">
                <li
                  v-for="(attachFile, index) in selectedCompanyMOU.attachFiles"
                  :key="index"
                >
                  <a
                    :href="attachFile.filePath"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="file-link"
                  >
                    <!-- <i class="fa fa-paperclip me-1"></i> -->
                    {{ attachFile.fileName }}
                  </a>
                </li>
              </ul>
            </b-col>
          </b-row>
        </b-row>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BForm,
  BButton,
  BCard,
  BFormTextarea,
  BFormCheckboxGroup,
  BFormCheckbox,
  BCardText,
  BListGroup,
  BImg,
} from "bootstrap-vue";
import CustomSelectGroup from "./CustomSelectGroup.vue";
import CustomRadioGroup from "./CustomRadioGroup.vue";

import * as ComplaintAPI from "@/store/api/complaint/complaint.js";

import Multiselect from "vue-multiselect";
import Personal from "./Personal.vue";

import Step2 from "./Step2.vue";
import Step3 from "./Step3.vue";

import PersonDataDigital from "../../components/PersonDataDigital.vue";

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckboxGroup,
    BFormCheckbox,
    BCardText,
    BForm,
    BButton,
    BCard,
    BFormTextarea,
    BListGroup,
    BImg,
    CustomSelectGroup,
    CustomRadioGroup,
    ComplaintAPI,
    Multiselect,
    Personal,
    Step2,
    Step3,
    PersonDataDigital,
  },
  props: {
    complaintCatagoryDetail: {
      type: Array,
      default: [],
    },
    personals: {
      type: Array,
    },
    attorneys: {
      type: Array,
    },
    company: {
      type: Object,
    },
    complaintDetail: {
      type: Array,
    },
    complaintDetailMultiSelect: {
      type: Array,
      default: [],
    },
    isAttorneyCompliant: false,
    complainantCompany: [],
    mouCompanies: [],
    needFastTrack: {
      type: Boolean,
      default: false,
    },
    selectedCompanyMOU: {
      type: Object,
      default: () => ({}),
    },
  },

  methods: {},
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.fast-track-icon {
  max-height: 32px;
}
</style>
